import { Stack, Tab, Tabs } from '@mui/material'
import type { MouseEvent } from 'react'
import { useFormContext, type UseFormSetValue } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { routesProfile } from '../../../consts'
import { USERS_FILTRATION } from '../../../consts/formOptions/usersFiltration'
import { TabsStyle } from './style'

const STATUS_LOOKING = USERS_FILTRATION.STATUS[1].value
const STATUS_OPEN = USERS_FILTRATION.STATUS[2].value

type UsersFilterForm = {
  query: string
  city: string
  status: string
  age_from: string
  age_to: string
}

function applySearchUpdate(
  navigate: ReturnType<typeof useNavigate>,
  setValue: UseFormSetValue<UsersFilterForm>,
  basePathname: string,
  current: URLSearchParams,
  patch: { status?: string | null },
): void {
  const next = new URLSearchParams(current)

  if (patch.status == null || patch.status === 'all') {
    next.delete('status')
    setValue('status', 'all', { shouldDirty: false })
  } else {
    next.set('status', patch.status)
    setValue('status', patch.status, { shouldDirty: false })
  }

  const qs = next.toString()
  navigate({ pathname: basePathname, search: qs ? `?${qs}` : '' }, { replace: true })
}

export const UsersTabs = () => {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const { setValue } = useFormContext<UsersFilterForm>()
  const usersPath = `/${routesProfile.USERS.path}`
  const subscriptionsPath = `${usersPath}/subscriptions`
  const currentParams = new URLSearchParams(search)
  const statusParam = currentParams.get('status')

  const currentTab = pathname.endsWith('/subscriptions')
    ? 1
    : statusParam === STATUS_LOOKING
      ? 2
      : statusParam === STATUS_OPEN
        ? 3
        : 0

  const handleTabClick =
    (basePathname: string, patch: { status?: string | null }) => (e: MouseEvent) => {
      e.preventDefault()
      applySearchUpdate(navigate, setValue, basePathname, currentParams, patch)
    }

  return (
    <Stack direction="column" gap={{ xs: 1.5, sm: 2 }} mb={2} sx={{ minWidth: 0 }}>
      <Tabs
        value={currentTab}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={TabsStyle}
      >
        <Tab label="Все" role="tab" onClick={handleTabClick(usersPath, { status: null })} />
        <Tab label="Подписки" role="tab" onClick={handleTabClick(subscriptionsPath, { status: null })} />
        <Tab
          label="В поиске проекта"
          role="tab"
          onClick={handleTabClick(usersPath, { status: STATUS_LOOKING })}
        />
        <Tab
          label="Открыты к предложениям"
          role="tab"
          onClick={handleTabClick(usersPath, { status: STATUS_OPEN })}
        />
      </Tabs>
    </Stack>
  )
}
